import React from 'react'
import "./Mobile_rech_view_plans.css"
import Common_recharge_page_banner from '../../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner';
import { Nav, Tab } from 'react-bootstrap';
import Tab_content_holder from './tab_content_holder/Tab_content_holder';
import Contribution from '../../../../home/contribution/Contribution';

function Mobile_rech_view_plans() {
    const breadcrumbData = [
        { label: "Services", path: "/services", active: false },
        { label: "Mobile Recharge", path: "/mobile-recharge", active: false },
        { label: "View Plans", active: true }
    ];

    return (
        <>
            <section className='Mobile_recharge_view_plans'>
                <Common_recharge_page_banner
                    title="MOBILE RECHARGES"
                    breadcrumbItems={breadcrumbData}
                />


                <div className="Mobile_Recharge">
                    <div className="container">
                        <div className="recharge_form_section form_box_section">
                            <Tab.Container id="left-tabs-example" defaultActiveKey="popular">
                                <div className="row ">
                                    <div className="col-md-4 mb-md-0 mb-3">
                                        <div className="Browse_Plans_holder box_holder">
                                            <div className="Browse_Plans_heading_holder">
                                                <h6>Browse Plans</h6>
                                                <p>Find The Perfect Prepaid And Postpaid Plans Tailored To Your Needs</p>
                                            </div>

                                            <div className="list_holder">
                                                <Nav variant="pills" className="flex-column">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="popular">Popular</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="true-5G-unlimited">True 5G Unlimited</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="data-add-on">Data Add on</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="international-roaming">International Roaming</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="smart-phone">Smart Phone</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="entertainment">Entertainment</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-8">

                                        <Tab.Content>
                                            <Tab.Pane eventKey="popular">
                                                <Tab_content_holder planHeading="Popular Plan:" />
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="true-5G-unlimited">
                                                <Tab_content_holder planHeading="True 5G Unlimited Plan" />
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="data-add-on">
                                                <Tab_content_holder planHeading="Data Add On Plan:" />
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="international-roaming">
                                                <Tab_content_holder planHeading="International Roaming Plan:" />
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="smart-phone">
                                                <Tab_content_holder planHeading="Smart Phone Plan:" />
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="entertainment">
                                                <Tab_content_holder planHeading="Entertainment Plan:" />
                                            </Tab.Pane>


                                        </Tab.Content>
                                    </div>
                                </div>
                            </Tab.Container>
                        </div>
                    </div>
                </div>

                <Contribution />


            </section>
        </>
    )
}

export default Mobile_rech_view_plans